import React from 'react';
import {
  StructuredTaskField,
  StructuredTaskFieldRow,
  StructuredTaskSection,
} from '../../../../common/components/StructuredTaskDetails';
import { Resource } from '../../../../common/constants/resource';
import { TRLCredit } from '../../../tasks/types/trl';
import { booleanToString } from '../../utilities/formattingUtilities';

export const RenderCreditSection = ({ credit }: { credit: TRLCredit }) => {
  const creditFields = [
    {
      label: Resource.TRL_CREDIT_CREDIT_DATA_SUPPRESSED,
      value: credit?.suppressed === true,
    },
    {
      label: Resource.TRL_CREDIT_CREDIT_FREEZE,
      value: credit?.freeze === true,
    },
    {
      label: Resource.TRL_CREDIT_MINOR,
      value: credit?.minor === true,
    },
    {
      label: Resource.TRL_CREDIT_DO_NOT_PROMOTE,
      value: credit?.promote === true,
    },
    {
      label: Resource.TRL_CREDIT_DISPUTED,
      value: credit?.dispute === true,
    },
  ].filter(field => field.value);

  if (!creditFields.length) {
    return <></>;
  }

  return (
    <StructuredTaskSection title={Resource.TRL_CREDIT_SUBTITLE}>
      <StructuredTaskFieldRow>
        {creditFields.map(field => (
          <StructuredTaskField
            key={field.label}
            label={field.label}
            value={booleanToString(field.value)}
          />
        ))}
      </StructuredTaskFieldRow>
    </StructuredTaskSection>
  );
};
